import React, { useEffect } from "react";

import {
  BarChart,
  Bar,
  AreaChart,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Area,
} from "recharts";
import { useSelector, useDispatch } from "react-redux";
import { getStockMovement } from "../../redux/Inventory/inventoryActions";
import { CustomTooltip } from "./InventoryCharts/ToolTip";
import { LineChartTooltip } from "./InventoryCharts/LineChartTooltip";

export const SimpleBarChart = ({data}) => {
  // const data = simpleData;
  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={data} barCategoryGap={8} barSize={24}>
        <CartesianGrid stroke="#5F6D60" strokeOpacity={0.1} vertical={false} />
        <XAxis dataKey="location" stroke="#5F6D60" fontSize={12} />
        <YAxis hide={true} stroke="#5F6D60" fontSize={12} />
        <Tooltip
          content={<CustomTooltip value={"Quantity Sold"} />}
          cursor={false}
        />
        <Bar dataKey="quantity_sold" fill="#2B8C34" radius={[4, 4, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export const TimeframeLineChart = ({ period }) => {
  const dispatch = useDispatch();
  const { lineChartData } = useSelector((state) => state.inventory);

  const formatChartData = (rawData) => {
    // Handle new data structure with in_stock and out_of_stock categories
    if (!rawData || typeof rawData !== 'object') {
      return [];
    }

    // Check if data has the new structure (in_stock, out_of_stock)
    if (rawData.in_stock && rawData.out_of_stock) {
      const months = Object.keys(rawData.in_stock);
      return months.map(month => {
        const monthName = month.charAt(0).toUpperCase() + month.slice(1); // "aug" → "Aug"
        return {
          name: monthName,
          in_stock: rawData.in_stock[month] || 0,
          out_of_stock: rawData.out_of_stock[month] || 0,
          total: (rawData.in_stock[month] || 0) + (rawData.out_of_stock[month] || 0),
        };
      });
    }

    // Fallback to old format for backward compatibility
    return Object.entries(rawData).map(([key, value]) => ({
      name: key.charAt(0).toUpperCase() + key.slice(1),
      value,
      total: value,
    }));
  };
  const chartData = formatChartData(lineChartData);

  useEffect(() => {
    dispatch(getStockMovement({ period }));
  }, [dispatch, period]);
  return (
    <div style={{ width: "100%", height: 500 }}>
      <ResponsiveContainer>
        <AreaChart
          data={chartData}
          margin={{ top: 10, right: 10, left: 0, bottom: 0 }}
        >
          <defs>
            <linearGradient id="inStockGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#EEF6EF" stopOpacity={1} />
              <stop offset="100%" stopColor="#F8FCF9" stopOpacity={0.5} />
            </linearGradient>
            <linearGradient id="outOfStockGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#EEF6EF" stopOpacity={1} />
              <stop offset="100%" stopColor="#F8FCF9" stopOpacity={0.5} />
            </linearGradient>
            <linearGradient id="totalGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#EEF6EF" stopOpacity={1} />
              <stop offset="100%" stopColor="#F8FCF9" stopOpacity={0.5} />
            </linearGradient>
          </defs>
          <CartesianGrid
            stroke="#5F6D60"
            strokeOpacity={0.1}
            vertical={false}
          />
          <XAxis dataKey="name" fontSize={12} />
          <YAxis hide />
          <Tooltip content={<LineChartTooltip />} />

          {/* Check if we have the new data structure */}
          {chartData.length > 0 && chartData[0].in_stock !== undefined ? (
            <>
              {/* In Stock Area - No stackId for separate display */}
              <Area
                type="monotone"
                dataKey="in_stock"
                stroke="#2B8C34"
                fill="url(#inStockGradient)"
                fillOpacity={0.6}
                strokeWidth={2}
                dot={false}
              />
              {/* Out of Stock Area - No stackId for separate display */}
              <Area
                type="monotone"
                dataKey="out_of_stock"
                stroke="#B92020"
                fill="url(#outOfStockGradient)"
                fillOpacity={0.4}
                strokeWidth={2}
                dot={false}
              />
            </>
          ) : (
            <Area
              type="monotone"
              dataKey="value"
              stroke="#2B8C34"
              fill="url(#totalGradient)"
              fillOpacity={1}
              strokeWidth={2}
              dot={false}
            />
          )}
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};
